import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoDocsPostRes } from "./abst/DtoDocsPostRes";

export class DtoDocsPostResImple extends DtoDocsPostRes {
  public url: string | null = null;
}
